import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=5c160f0d&scoped=true"
import script from "./diagnosis.vue?vue&type=script&lang=js"
export * from "./diagnosis.vue?vue&type=script&lang=js"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=5c160f0d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c160f0d",
  null
  
)

export default component.exports